import React from "react";
import DisRoutes from "@/routes/DisRoutes";

interface RouteSidebar {
  show: boolean;
  icon?: string | React.ElementType | undefined;
  name?: string;
}

interface RouteConfig {
  path: string;
  element?: React.ReactNode;
  pageName?: string;
  permissionName?: string;
  sidebar?: RouteSidebar;
  roles?: string[];
  children?: Record<string, RouteConfig>;
}

export interface SidebarChild {
  id: string;
  path: string;
  icon?: string | React.ElementType | undefined;
  pageName?: string | undefined;
  permissionName?: string | undefined;
}

export interface SidebarItem {
  id: string;
  path: string;
  icon?: string | React.ElementType | undefined;
  pageName?: string | undefined;
  permissionName?: string | undefined;
  children?: SidebarChild[];
}

export function sideBarNavigation(): SidebarItem[] {
  const routes = DisRoutes.privateRoutes as Record<string, RouteConfig>;

  // ⭐ GET ROLE FROM URL (distributor / retailer)
  const role: string = window.location.pathname.split("/")[1] ?? "";
  return Object.values(routes)
    .filter((page) => {
      // ⭐ ROLE FILTER ADDED
      if (page.roles && !page.roles.includes(role)) return false;

      return page.sidebar?.show || page.children;
    })
    .map((pageData, index) => {
      const data: SidebarItem = {
        id: (index + 1).toString(),
        path: pageData.path ?? "",
        icon: pageData.sidebar?.icon,
        pageName: pageData.sidebar?.name || pageData.pageName,
        permissionName: pageData.permissionName,
      };

      if (pageData.children) {
        data.children = mapChildren(pageData.children, data.id, role);
      }

      return data;
    });
}

function mapChildren(
  children: Record<string, RouteConfig>,
  parentId: string,
  role: string
): SidebarItem[] {
  return Object.values(children)
    .filter((child) => {
      // ⭐ ROLE FILTER FOR CHILDREN TOO
      if (child.roles && !child.roles.includes(role)) return false;

      return child.sidebar?.show || child.children;
    })
    .map((child, childIndex) => {
      const id = `${parentId}-${childIndex + 1}`;

      const mappedChild: SidebarItem = {
        id,
        path: child.path,
        icon: child.sidebar?.icon,
        pageName: child.sidebar?.name || child.pageName,
        permissionName: child.permissionName,
      };

      if (child.children) {
        mappedChild.children = mapChildren(child.children, id, role);
      }

      return mappedChild;
    });
}
